import {
  PDP_CUSTOMIZE_TAB_ID,
  PDP_READYTOSHIP_TAB_ID,
  PDP_DECIDELATER_TAB_ID,
} from 'commons/constants';

const customItem = {
  id: PDP_CUSTOMIZE_TAB_ID,
  contentId: `${PDP_CUSTOMIZE_TAB_ID}-content`,
  label: 'Customize',
  description: 'Built just for you',
};

const readyToShipItem = {
  id: PDP_READYTOSHIP_TAB_ID,
  contentId: `${PDP_READYTOSHIP_TAB_ID}-content`,
  label: 'Ready to Ship',
  description: 'In stock options',
  infoTooltip: true,
  infoTooltipContent:
    'This product has already been built, and will ship from the factory within 2 weeks of placing your order, using our standard shipping method.',
};

const decideLaterItem = {
  id: PDP_DECIDELATER_TAB_ID,
  contentId: `${PDP_DECIDELATER_TAB_ID}-content`,
  label: 'Decide Later',
  description: 'Lock in 20% discount',
};

export { customItem, readyToShipItem, decideLaterItem };
